/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

export const initialState = {
  people: [],
  properties: [],
  tasks: [],
};

export default (state = initialState, action) => {
  const { payload, type, meta } = action;
  switch (type) {
    case t.CHANGE_SELECTED_PERSON_IDS:
    case t.CHANGE_SELECTED_PROPERTY_IDS:
    case t.CHANGE_SELECTED_TASK_IDS: {
      return {
        ...state,
        [meta]: payload,
      };
    }
    default:
      return state;
  }
};
